<p class="text-center">Unknown component for workflow: {{component.componentType}}</p>
